module.exports = RedNaoSharedCore.default('shared/core/Events/EventManager');